import { useEffect, useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import { toast } from "react-toastify";
import API from "../../Api/axiosConfig";
import { useTranslation } from "react-i18next";
import { FloatingLabel, Form } from "react-bootstrap";
import { toLocal } from "../../utils/toLocal";

function Cash() {
  const { t } = useTranslation();

  const [filters, setFilters] = useState({
    from: "",
    to: "",
    branch_uuid: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [cashBalance, setCashBalance] = useState(null);
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    API.get("/branches")
      .then((res) => setBranches(res.data.data || []))
      .catch((err) => console.error("Failed to load branches", err));
  }, []);

  // دالة مساعدة لتنسيق الأرقام السالبة والموجبة حسب المطلوب
  const formatNumberWithColor = (value) => {
    const num = Number(value);
    if (isNaN(num)) return "-";

    if (num < 0) {
      // إذا كان الرقم سالبًا: نأخذ القيمة المطلقة، نمررها لـ toLocal لتضع الكومة، ثم نضعها بين قوسين
      const absoluteFormatted = toLocal(Math.abs(num));
      return (
        <span className="text-danger fw-bold" style={{ direction: "ltr", display: "inline-block" }}>
          ({absoluteFormatted})
        </span>
      );
    }

    // إذا كان الرقم موجبًا أو صفرًا يظهر بالفواصل بشكل طبيعي
    return <span>{toLocal(num)}</span>;
  };

  const columns = [
    { header: t("cash_date"), accessor: "date" },
    { header: t("type"), accessor: (row) => t(row.type) || "-" },
    {
      header: t("cash_invoice_number"),
      // 🟢 فحص مزدوج: إذا لم تكن الفاتورة داخل money_invoice، نبحث عنها في الحقل المباشر row.invoice_number
      accessor: (row) => row.money_invoice?.invoice_number || row.invoice_number || "-",
    },
    {
      header: t("payment_method"),
      // 🟢 فحص مزدوج: إذا لم تكن الفاتورة داخل money_invoice، نبحث عنها في الحقل المباشر row.invoice_number
      accessor: (row) => t(row?.cash_type) ||  "-",
    },
    {
      header: t("cash_operation_value"),
      // 🟢 تطبيق التنسيق الملون والقوسين على قيمة العملية
      accessor: (row) => formatNumberWithColor(row.value),
    },
    {
      header: t("cash_balance_after"),
      // 🟢 تطبيق التنسيق الملون والقوسين على الرصيد المتبقي
      accessor: (row) => formatNumberWithColor(row.total_value),
    },
  ];

  const handleSearch = () => {
    if (!filters.branch_uuid) {
      toast.error(t("select_branch"));
      return;
    }

    setAppliedFilters(filters);
    setRefreshKey((prev) => prev + 1);
  };

  const totalValue = (value) => {
    setCashBalance(value);
  };

  // 🟢 تفعيل البحث التلقائي بمجرد اختيار الفرع والتواريخ دون الحاجة لزر بحث
  useEffect(() => {
    if (filters.branch_uuid && filters.from && filters.to) {
      setAppliedFilters(filters);
      setRefreshKey((prev) => prev + 1);
    } else {
      setAppliedFilters(null);
    }
  }, [filters.branch_uuid, filters.from, filters.to]);

  useEffect(() => {
    const today = new Date();

    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setFilters((prev) => ({
      ...prev,
      to: formatDate(lastDay),
      from: formatDate(firstDay),
    }));
  }, []);

  return (
    <div className="container mt-5">
      <Mytitle title={t("cash_title")} />

      {cashBalance !== null && (
        <div className="alert alert-info text-end fw-bold">
          {t("cash_current_balance")}{" "}
          {branches.find((b) => b.uuid === appliedFilters?.branch_uuid)?.name || ""}{" "}
          :{" "}
          <span className="text-success">
            {Math.trunc(cashBalance?.total_value)}
          </span>
        </div>
      )}

      <div className="row flex-row mb-3">
        <div className="col-md-2">
          <MyInput
            label={t("cash_from")}
            type="date"
            value={filters.from}
            onChange={(e) => setFilters({ ...filters, from: e.target.value })}
            dontShowDay={true}
          />
        </div>
        <div className="col-md-2">
          <MyInput
            label={t("cash_to")}
            type="date"
            value={filters.to}
            onChange={(e) => setFilters({ ...filters, to: e.target.value })}
            dontShowDay={true}
          />
        </div>

        <div className="col-md-2">
          <FloatingLabel label={t("branch")}>
            <Form.Select
              className="form-select mb-3"
              style={{ height: "38px" }}
              value={filters.branch_uuid}
              onChange={(e) =>
                setFilters({ ...filters, branch_uuid: e.target.value })
              }
            >
              <option value="">{t("select_branch")}</option>
              {branches.map((opt, j) => (
                <option key={j} value={opt.uuid}>
                  {opt.name}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </div>
      </div>

      {appliedFilters && (
        <MyTable
          title={t("cash_title")}
          resource="cash-report"
          method="post"
          body={appliedFilters}
          columns={columns}
          refreshKey={refreshKey}
          cashBalance={cashBalance}
          setCashBalance={setCashBalance}
          totalValue={totalValue}
          button={{}}
          component="cash"
        />
      )}
    </div>
  );
}

export default Cash;